export default {
  "studyPreview.studyPreview": "Study Preview",
  "studyPreview.studySchedule": "Study Schedule",
  "studyPreview.studyScheduleKey": "Study Schedule Key",
  "studyPreview.studyVersion": "Version {major}.{minor}",
  "studyPreview.showKey": "Show Key",
  "studyPreview.hideKey": "Hide Key",
  "studyPreview.scheduleKey": "Schedule Key",
  "studyPreview.keySurveyOnce": "Survey Is Available Once",
  "studyPreview.keySurveyRecurring": "Survey Is Recurring",
  "studyPreview.keySurveyAsNeeded": "Survey Is As Needed",
  "studyPreview.scheduleOnce": "Available Once",
  "studyPreview.scheduleRecurring": "Recurring",
  "studyPreview.scheduleAsNeeded": "As Needed",
  "studyPreview.scheduleAsNeededWithTimes": "As Needed {startTime} - {endTime}",
  "studyPreview.scheduleAsNeededDuration": "As Needed {duration}",
  "studyPreview.scheduleBetweenExpectedWindow": "Until {endTime}",
  "studyPreview.scheduleBetweenExpectedWindowWithOffsetDay":
    "Until {endTime}, offset by {offset} day",
  "studyPreview.scheduleBetweenExpectedWindowWithOffsetDays":
    "Until {endTime}, offset by {offset} days",
  "studyPreview.scheduleAvailabilityTimes": "{startTime} - {endTime}",
  "studyPreview.scheduleAvailabilityTimesWithOffsetDay":
    "{startTime} - {endTime}, offset by 1 day",
  "studyPreview.scheduleAvailabilityTimesWithOffsetDays":
    "{startTime} - {endTime}, offset by {offset} days",
  "studyPreview.location": "Location",
  "studyPreview.locationAll": "All",
  "studyPreview.locationInClinic": "In-Clinic",
  "studyPreview.locationRemote": "Remote",
  "studyPreview.selectGroups": "Select Groups",
  "studyPreview.selectGroupsDescription":
    "Select groups to view survey schedules",
  "studyPreview.continue": "Continue",
  "studyPreview.noSurveysTitle": "No Surveys to Display",
  "studyPreview.noSurveysDescription":
    "Try selecting different criteria to view the survey schedules.",
  "studyPreview.surveyType": "Survey Type",
  "studyPreview.respondent": "Respondent",
  "studyPreview.respondent.sitestaff": "Site Staff",
  "studyPreview.respondent.participant": "Participant",
  "studyPreview.respondent.caregiver": "Caregiver",
  "studyPreview.event": "Event",
  "studyPreview.eventDetails": "Event Details",
  "studyPreview.scheduleOptions": "Schedule Options",
  "studyPreview.groupOptions": "Group Options",
  "studyPreview.groupTypeNotApplicable": "Group Type is not applicable.",
  "studyPreview.groupTypesAssignedAtEvent": "Group Types Assigned At Event",
  "studyPreview.applicableGroupsForEvent": "Applicable Groups For Event",
  "studyPreview.groupTypesAssignedAtEventTooltip":
    "Site staff must assign participant to group types at this event",
  "studyPreview.applicableGroupsForEventTooltip":
    "Event only applies for participants in these groups",
  "studyPreview.unscheduledEventLabelTooltip":
    "Unscheduled Events do not appear in participant event lists unless added by a site.",
  "studyPreview.anchorEvent": "Anchor Event:",
  "studyPreview.defaultTime": "Default Time:",
  "studyPreview.visitWindow": "Visit Window:",
  "studyPreview.noGroupsSelected": "No Groups Selected",
  "studyPreview.select": "Select",
  "studyPreview.assignedAtEvent": "Assigned at Event(s): <br></br> {events}",
  "studyPreview.clear": "Clear",
  "studyPreview.scheduleCell":
    "Survey {surveyName}, Event {eventName}, {scheduleCount} indicators",
  "studyPreview.checkEventDescription":
    "This is a check event. This event has no surveys but may still require action from site staff.",
  "studyPreview.randomizationEventDescription":
    "Select a group from the <medium>{groupTypes}</medium> list to populate the schedule",
  "studyPreview.expectedDate": "Expected Date:",
  "studyPreview.expectedAnchorDate": "{eventLabel} +{dayOffset} days",
  "studyPreview.eventWindow": "Event Window:",
  "studyPreview.eventWindowRange":
    "-{windowDaysBefore} days / +{windowDaysAfter} days",
  "studyPreview.clickToPreview": "Click To Preview",
  "studyPreview.close": "Close",
  "studyPreview.details": "Details",
  "studyPreview.respondentField": "Respondent: {respondentType}",
  "studyPreview.training": "Training",
  "studyPreview.diary": "Diary",
  "studyPreview.restricted": "Restricted",
  "studyPreview.previewSurvey": "Preview Survey",
  "studyPreview.schedule": "Schedule",
  "studyPreview.groupTag":
    "<semibold>{groupTypeLabel}:</semibold> {groupLabel}",
  "studyPreview.locationField": "Location:",
  "studyPreview.availableField": "Available:",
  "studyPreview.expectedWindowField": "Expected Window:",
  "studyPreview.allowsPartialWindowField": "Send in Partial Window:",
  "studyPreview.yes": "Yes",
  "studyPreview.no": "No",
  "studyPreview.delayField": "Delay:",
  "studyPreview.recurrenceField": "Recurrence:",
  "studyPreview.timepoint": "Timepoint:",
  "studyPreview.startEventsField": "Start Events:",
  "studyPreview.startRulesField": "Start Rules:",
  "studyPreview.endEventsField": "End Events:",
  "studyPreview.showNotifications": "Show {count} Notifications",
  "studyPreview.hideNotifications": "Hide {count} Notifications",
  "studyPreview.notification.messageField": "Message:",
  "studyPreview.notification.recipientField": "Recipient:",
  "studyPreview.notification.sendWhenField": "Send When:",
  "studyPreview.notification.recurs": "Recurs:",
  "studyPreview.notification.defaultDeliveryTime": "Default Delivery Time:",
  "studyPreview.notification.titleField": "Title:",
  "studyPreview.notification.recipientParticipantAndOrCaregiver":
    "Participant and/or Caregiver",
  "studyPreview.notification.recipientSiteUser": "Site Staff",
  "studyPreview.notification.sendWhenAvailable": "Available",
  "studyPreview.notification.sendWhenAvailableOffset": "Available {timeOffset}",
  "studyPreview.notification.sendWhenDue": "Due",
  "studyPreview.notification.sendWhenDueOffset": "Due {timeOffset}",
  "studyPreview.notification.sendWhenMissed": "Missed",
  "studyPreview.notification.sendWhenMissedCount": "Missed {numMissed}",
  "studyPreview.notification.sendWhenComplete": "Complete",
  "studyPreview.notification.deliveryFrequency.daily": "Daily",
  "studyPreview.notification.deliveryFrequency.weekly": "Weekly",
  "studyPreview.notification.deliveryFrequency.custom": "Custom",
  "studyPreview.statusStudyComplete": "Study Complete",
  "studyPreview.timeSpan.one.Days": `{value} Day`,
  "studyPreview.timeSpan.other.Days": `{value} Days`,
  "studyPreview.timeSpan.one.Hours": `{value} Hour`,
  "studyPreview.timeSpan.other.Hours": `{value} Hours`,
  "studyPreview.timeSpan.one.Minutes": `{value} Minute`,
  "studyPreview.timeSpan.other.Minutes": `{value} Minutes`,
  "studyPreview.timeSpan.one.Months": `{value} Month`,
  "studyPreview.timeSpan.other.Months": `{value} Months`,
  "studyPreview.timeSpan.one.Seconds": `{value} Second`,
  "studyPreview.timeSpan.other.Seconds": `{value} Seconds`,
  "studyPreview.timeSpan.one.Weeks": `{value} Week`,
  "studyPreview.timeSpan.other.Weeks": `{value} Weeks`,
  "studyPreview.timeSpan.one.Years": `{value} Year`,
  "studyPreview.timeSpan.other.Years": `{value} Years`,
  "studyPreview.timepointParentLabel": "timepoint",
  "studyPreview.dayOfWeek": "dayOfWeek",
  "studyPreview.availableWhenField": "Available When:",
  "studyPreview.populatedByField": "Populated By:",
  "studyPreview.availableWhen.always": "Always",
  "studyPreview.availableWhen.afterPreviousEvent": "After Previous Event",
  "studyPreview.availableWhen.rule": "Rule",
  "studyPreview.populatedBy.site": "Site",
  "studyPreview.populatedBy.api": "API",
  "studyPreview.populatedBy.rule": "Rule",
  "studyPreview.survey": "Survey",
  "studyPreview.compliance.event": "Event",
  "studyPreview.compliance.surveyType": "Survey Type",
  "studyPreview.compliance.complianceCell":
    "{chipCount} instances for {surveyName} {eventName}",
  "studyPreview.compliance.unscheduledEventLabelTooltip":
    "Unscheduled Events do not appear in participant event lists unless added by a site.",
  "studyPreview.compliance.location": "Location",
  "studyPreview.compliance.all": "All",
  "studyPreview.compliance.in-Clinic": "In-Clinic",
  "studyPreview.compliance.remote": "Remote",
  "studyPreview.compliance.tableView": "Table View",
  "studyPreview.compliance.noSurveysTitle": "No Surveys to Display",
  "studyPreview.compliance.close": "Close",
  "studyPreview.compliance.details": "Details",
  "studyPreview.compliance.respondent": "Respondent",
  "studyPreview.compliance.siteStaff": "Site Staff",
  "studyPreview.compliance.participant": "Participant",
  "studyPreview.compliance.caregiver": "Caregiver",
  "studyPreview.compliance.timepointParentLabel": "timepoint",
  "studyPreview.compliance.dayOfWeek": "dayOfWeek",
  "studyPreview.compliance.details.respondentWithType":
    "Respondent: {respondentType}",
  "studyPreview.compliance.details.restricted": "Restricted",
  "studyPreview.compliance.details.surveyInstances": "Survey Instances",
  "studyPreview.compliance.details.available": "Available",
  "studyPreview.compliance.details.missed": "Missed",
  "studyPreview.compliance.details.completed": "Completed",
  "studyPreview.compliance.details.intentionallyLeftBlank":
    "Intentionally Left Blank",
  "studyPreview.compliance.details.transcribed": "Transcribed",
  "studyPreview.compliance.details.availablePercent":
    "Available ({percentage}%)",
  "studyPreview.compliance.details.missedPercent": "Missed ({percentage}%)",
  "studyPreview.compliance.details.completedPercent":
    "Completed ({percentage}%)",
  "studyPreview.compliance.details.intentionallyLeftBlankPercent":
    "Intentionally Left Blank ({percentage}%)",
  "studyPreview.compliance.details.transcribedPercent":
    "Transcribed ({percentage}%)",
  "studyPreview.compliance.details.viewSurvey": "View Survey",
}
